import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import {
  INITIAL_REMOVE_CO_GUARDIAN_FORM,
  removeCoGuardianSchema,
  type RemoveCoGuardianForm,
} from '@/features/guardian-player/schemas/remove-co-guardian-schema';

/** react-hook-form instance for the Remove Co-Guardian screen (validated live so the
 * Remove button can enable only once a reason is picked and the box is checked). */
export function useRemoveCoGuardianForm() {
  return useForm<RemoveCoGuardianForm>({
    mode: 'onChange',
    resolver: yupResolver(removeCoGuardianSchema) as never,
    defaultValues: INITIAL_REMOVE_CO_GUARDIAN_FORM,
  });
}

export default useRemoveCoGuardianForm;
